import React,{useState,useEffect} from 'react'
import {toast} from 'react-toastify'
import recallsService from '../../../../../services/recalls.service'
import {useForm,Controller } from 'react-hook-form'
import { useParams } from 'react-router-dom'

function RecallTimings() {
    const {clinicId} = useParams()
    const [recallTimings,setRecallTimings]  = useState([])
    const [editing,setEditing] = useState(false)

    useEffect(()=>{
            getRecallTimings()
    },[])

    const getRecallTimings = ()=>{
        recallsService.getClinicTimings(clinicId)
        .then(res=>{
            setRecallTimings(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
    }

    const handleUpdateTiming = (newTiming)=>{
        setRecallTimings(newTiming)
    }

    return (
   <>
        <div className="d-flex justify-content-end">
            <button className="btn btn-sm btn-secondary" onClick={()=>setEditing(!editing)}>Edit</button>
        </div>
        {recallTimings && <>
            {editing? <RecallTimingForm timings={recallTimings} updateTiming={handleUpdateTiming}/>:<RecallTimingView timings={recallTimings}/>}
        </>}
   </>
  )
}

const RecallTimingView = ({timings})=>{
    return(<>
           <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Day</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                    </tr>
                </thead>
                <tbody>
                    {timings.map((timing,index)=>{
                          return(
                                <tr key={index}>
                                    <td>{timing.day}</td>
                                    <td>{timing.start}</td>
                                    <td>{timing.end}</td>
                                </tr>
                          )  
                    })}
                </tbody>
           </table>
        </>)
}
const RecallTimingForm = ({timings,updateTiming})=>{
    const { control, handleSubmit } = useForm();
    const onSubmit = (data) => {
        console.log(data); // Do something with the modified time slots
        const newData = timings.map((item,index)=>{
            return ({
                id:item.id,
                clinicId:item.clinicId,
                day: item.day,
                start:data.timings[index].start,
                end:data.timings[index].end
            })
        })
        
        recallsService.saveClinicTimings(timings[0].clinicId,newData)
        .then(res=>{
            toast.success("Recall Timings Updated",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            updateTiming(res.data)
        })
        .catch(err=>{
            toast.error("Error while Updating Recall",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            console.log(err)
        })
       
      };
    
    
    return(<>
     <form onSubmit={handleSubmit(onSubmit)}>
         <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Day</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                    </tr>
                </thead>
                <tbody>
               
                    {timings.map((timing,index)=>{
                          return(
                                <tr key={index}>
                                    <td>{timing.day}</td>
                                    <td>
                                    <Controller
                                        name={`timings[${index}].start`}
                                        control={control}
                                    
                                        defaultValue={timing.start}
                                        render={({ field }) => (
                                            <input
                                            type="time"
                                            className='form-control'
                                            {...field}
                                            onChange={(e) => field.onChange(e.target.value)}
                                            />
                                        )}
                                        />

                                    </td>
                                    <td>
                                    <Controller
                                        name={`timings[${index}].end`}
                                        control={control}
                                        defaultValue={timing.end}
                                        render={({ field }) => (
                                            <input
                                            type="time"
                                            className='form-control'
                                            {...field}
                                            onChange={(e) => field.onChange(e.target.value)}
                                            />
                                        )}
                                        />
                                    </td>
                                </tr>
                          )  
                    })}
                    <tr>
                        <td></td>
                        <td>
                            <button className='btn btn-sm btn-primary' type="submit">Submit</button>
                        </td>
                    </tr>
               
                </tbody>
           </table>
        </form>
    </>
    )
}
export default RecallTimings